import CenterTile from './CenterTile';
import CentersPanelHeaderTile from './CentersPanelHeaderTile';
import { useSelectedGcsConfigsStore } from '../../../store/useSelectedGcsConfigsStore';
import FloatingCard from '../../../components/general/FloatingCard';
import type { MapRef } from 'react-map-gl/mapbox';

interface CentersPanelProps {
  flightMapRef: React.RefObject<MapRef | null>;
}

const CentersPanel: React.FC<CentersPanelProps> = ({ flightMapRef }) => {
  const { selectedConfigs } = useSelectedGcsConfigsStore();

  return (
    <FloatingCard>
      <CentersPanelHeaderTile mapRef={flightMapRef} />
      {selectedConfigs.map((config) => {
        return <CenterTile key={config.id} gcsId={config.id} mapRef={flightMapRef} />;
      })}
    </FloatingCard>
  );
};

export default CentersPanel;
